import React, { useEffect } from "react";
import { connect } from "react-redux";

import * as DriverBannerActions from "../../../store/actions/DriverBanner";

import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import { bindActionCreators } from "redux";
import BannerDetailsForm from "../BannerDetailsForm";
import { useLocation } from "react-router-dom";

const BannerDetails = (props) => {
  const { getBannerDetails, bannerDetails } = props;
  const allActions = MenuActionsMappings[MenuNames.DRIVER_BANNER];
  const query = new URLSearchParams(useLocation()?.search);
  const userAction = query.get("action");
  const bannerId = query.get("id");

  useEffect(() => {
    if (bannerId) {
      getBannerDetails(bannerId);
    }
  }, [bannerId]);

  return (
    <BannerDetailsForm bannerDetails={bannerDetails} userAction={userAction} />
  );
};

function mapStateToProps(state) {
  const { DriverBanner } = state;

  console.log("DriverBanner", DriverBanner);

  return {
    bannerDetails: DriverBanner?.driverBannerDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getBannerDetails: bindActionCreators(
      DriverBannerActions.getBannerDetails,
      dispatch
    ),
    resetState: bindActionCreators(DriverBannerActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BannerDetails);
